/**
 * Vinheria — Cart JS
 * Gerencia: qty +/-, cupom, observações
 * Usa endpoints AJAX do Shopify: /cart/change.js, /cart/update.js
 * Atualização sem reload: edita DOM com base no JSON retornado
 *
 * Versão resiliente: funciona com ou sem atributos data-vin-cart-subtotal
 * no liquid. Usa busca por classe + texto como fallback.
 */
(function() {
  'use strict';

  /* ============================================================
     HELPER: formata centavos como BRL "R$ 1.234,56"
     ============================================================ */
  function formatBRL(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  /* ============================================================
     HELPER: encontra o elemento do Subtotal usando 3 estratégias
     ============================================================ */
  function findSubtotalEl() {
    // Estratégia 1: data attribute dedicado (caso o liquid tenha sido atualizado)
    var el = document.querySelector('[data-vin-cart-subtotal]');
    if (el) return el;

    // Estratégia 2: procura na .vin-cart-summary o row cujo label diz "Subtotal"
    var rows = document.querySelectorAll('.vin-cart-summary .vin-summary-row');
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('span:first-child');
      if (label && label.textContent.trim().toLowerCase() === 'subtotal') {
        return rows[i].querySelector('strong') || rows[i].querySelector('span:last-child');
      }
    }
    return null;
  }

  /* ============================================================
     HELPER: encontra o elemento do Total usando 2 estratégias
     ============================================================ */
  function findTotalEl() {
    var el = document.querySelector('[data-vin-cart-total]');
    if (el) return el;
    return document.querySelector('.vin-summary-total-value');
  }

  /* ============================================================
     HELPER: atualiza cart UI a partir do objeto cart retornado pela API
     ============================================================ */
  function updateCartUI(cart) {
    if (!cart || typeof cart !== 'object') return;

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function(line) {
        var itemEl = document.querySelector('[data-cart-item="' + line.key + '"]');
        if (!itemEl) return;

        itemEl.dataset.quantity = line.quantity;

        var qtyNum = itemEl.querySelector('.vin-qty-num');
        if (qtyNum) qtyNum.textContent = line.quantity;

        var lineP = itemEl.querySelector('[data-vin-item-line-price]');
        if (lineP) lineP.textContent = formatBRL(line.final_line_price);

        var minusBtn = itemEl.querySelector('[data-vin-qty-change="-1"]');
        if (minusBtn) {
          if (line.quantity === 1 && !minusBtn.classList.contains('danger')) {
            minusBtn.classList.add('danger');
            minusBtn.setAttribute('aria-label', 'Remover item');
            minusBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
          } else if (line.quantity > 1 && minusBtn.classList.contains('danger')) {
            minusBtn.classList.remove('danger');
            minusBtn.setAttribute('aria-label', 'Remover um');
            minusBtn.innerHTML = '−';
          }
        }
      });
    }

    var subtotalEl = findSubtotalEl();
    if (subtotalEl && typeof cart.items_subtotal_price !== 'undefined') {
      subtotalEl.textContent = formatBRL(cart.items_subtotal_price);
    }

    var freeshipBar = document.querySelector('[data-vin-freeship-bar]');
    if (freeshipBar && typeof cart.items_subtotal_price !== 'undefined') {
      freeshipBar.dataset.cartSubtotal = (cart.items_subtotal_price / 100).toFixed(2);
    }

    var totalEl = findTotalEl();
    if (totalEl && typeof cart.total_price !== 'undefined') {
      totalEl.textContent = formatBRL(cart.total_price);
    } else if (totalEl && typeof cart.items_subtotal_price !== 'undefined') {
      totalEl.textContent = formatBRL(cart.items_subtotal_price);
    }

    var pageSubEl = document.querySelector('.vin-page-sub');
    if (pageSubEl && typeof cart.item_count !== 'undefined') {
      pageSubEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' itens');
    }

    var cartBadges = document.querySelectorAll('[data-vin-cart-count]');
    cartBadges.forEach(function(badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  /* ============================================================
     1. QUANTIDADE +/-
     Update cirúrgico (preserva botão Yampi)
     ============================================================ */
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-vin-qty-change]');
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled) return;

    const change = parseInt(btn.dataset.vinQtyChange, 10);
    const item = btn.closest('[data-cart-item]');
    if (!item) return;

    const lineKey = item.dataset.cartItem;
    const currentQty = parseInt(item.dataset.quantity, 10) || 1;
    const newQty = Math.max(0, currentQty + change);

    btn.disabled = true;
    item.style.opacity = '0.6';
    item.style.pointerEvents = 'none';

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      });

      if (!res.ok) {
        const err = await res.json().catch(function() { return {}; });
        if (window.VinheriaToast) {
          window.VinheriaToast(err.description || 'Erro ao atualizar quantidade');
        }
        item.style.opacity = '';
        item.style.pointerEvents = '';
        btn.disabled = false;
        return;
      }

      const cart = await res.json();

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      updateCartUI(cart);

      if (typeof renderFreeshipBar === 'function') {
        renderFreeshipBar();
      }

      // Invalida o cache de checkout pré-computado (otimização de velocidade)
      window.dispatchEvent(new CustomEvent('vinheria:cart-updated'));

      item.style.opacity = '';
      item.style.pointerEvents = '';
      btn.disabled = false;
    } catch (err) {
      if (window.VinheriaToast) {
        window.VinheriaToast('Erro de conexão. Tente novamente.');
      }
      item.style.opacity = '';
      item.style.pointerEvents = '';
      btn.disabled = false;
    }
  });

  /* ============================================================
     2. SINCRONIZAR ENDEREÇO (do localStorage do modal CEP)
     ============================================================ */
  /* ============================================================
     2. SINCRONIZAR ENDEREÇO (do localStorage do modal CEP)
     ============================================================ */
  function updateCartAddress(address) {
    try {
      const display = document.querySelector('[data-vin-cart-address-value]');
      if (!display) return;

      let text = '';
      if (address.bairro && address.cidade) {
        text = address.bairro + ', ' + address.cidade;
      } else if (address.cidade) {
        text = address.cidade + ' · ' + (address.uf || '');
      }
      if (text) display.textContent = text;

      const zoneDisplay = document.querySelector('[data-vin-cart-zone]');
      if (zoneDisplay && address.zone) {
        zoneDisplay.textContent = address.zone.time || '';
      }
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function() {
    try {
      const saved = localStorage.getItem('vinheria_address');
      if (!saved) return;
      updateCartAddress(JSON.parse(saved));
    } catch (e) {}
  });

  /* ============================================================
     3. APLICAR CUPOM
     ============================================================ */
  function showCouponMessage(text, type) {
    const msg = document.querySelector('[data-vin-coupon-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.style.display = 'block';
    if (type === 'success') {
      msg.style.background = 'rgba(80, 167, 115, 0.12)';
      msg.style.color = '#2A7A3A';
    } else if (type === 'error') {
      msg.style.background = 'rgba(197, 48, 48, 0.08)';
      msg.style.color = '#C53030';
    } else {
      msg.style.background = 'var(--cream-soft, #FCFBF9)';
      msg.style.color = 'var(--ink-soft, #717171)';
    }
  }

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-vin-coupon-apply]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    const input = document.querySelector('[data-vin-coupon-input]');
    if (!input) return;

    const code = input.value.trim();
    if (!code) {
      showCouponMessage('Digite um código de cupom.', 'error');
      input.focus();
      return;
    }

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Aplicando...';
    showCouponMessage('Verificando cupom...', 'info');

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      });

      const cart = await res.json();

      if (!res.ok) {
        showCouponMessage('Não foi possível aplicar o cupom. Tente novamente.', 'error');
        return;
      }

      const applied = cart.cart_level_discount_applications &&
                      cart.cart_level_discount_applications.length > 0;
      const codeMatch = applied && cart.cart_level_discount_applications.some(d =>
        (d.title || '').toUpperCase() === code.toUpperCase()
      );

      if (codeMatch) {
        showCouponMessage('✓ Cupom aplicado! O desconto será exibido no checkout.', 'success');
        setTimeout(function() { window.location.reload(); }, 1500);
      } else {
        showCouponMessage('Cupom inválido ou expirado.', 'error');
      }
    } catch (err) {
      showCouponMessage('Erro de conexão. Tente novamente.', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('[data-vin-coupon-input]');
    if (!input) return;
    e.preventDefault();
    const btn = document.querySelector('[data-vin-coupon-apply]');
    if (btn) btn.click();
  });

  /* ============================================================
     FAIXA DE FRETE GRÁTIS
     ============================================================ */
  function formatBRLReais(v) {
    return 'R$ ' + Number(v).toFixed(2).replace('.', ',');
  }

  function getSavedAddress() {
    try {
      var raw = localStorage.getItem('vinheria_address');
      return raw ? JSON.parse(raw) : null;
    } catch(e) { return null; }
  }

  function isMotoboyCidade(addr) {
    if (!addr) return false;
    // Fonte de verdade: zone.time salvo da FRETE_TABLE.
    // Qualquer CEP com prazo "50-55 min" exibe o bloco "Receba hoje".
    if (addr.zone && addr.zone.time === '50-55 min') return true;
    // Fallback por cidade para o ABC (prazo em dias, mas modo motoboy)
    var cidade = (addr.cidade || addr.localidade || '').toLowerCase().trim();
    var uf = (addr.uf || addr.estado || '').toUpperCase().trim();
    if (uf !== 'SP') return false;
    var abcCidades = [
      'santo andré', 'são bernardo do campo', 'são caetano do sul',
      'diadema', 'mauá', 'ribeirão pires', 'rio grande da serra'
    ];
    return abcCidades.indexOf(cidade) !== -1;
  }

  function labelCidade(addr) {
    var cidade = (addr.cidade || addr.localidade || '').toLowerCase().trim();
    var alphaville = ['barueri', 'santana de parnaíba'];
    var abc = ['santo andré', 'são bernardo do campo', 'são caetano do sul',
               'diadema', 'mauá', 'ribeirão pires', 'rio grande da serra'];
    if (alphaville.indexOf(cidade) !== -1) return 'em Alphaville';
    if (abc.indexOf(cidade) !== -1) return 'no ABC';
    return 'em SP capital';
  }

  // Verifica se o endereço é elegível pra frete grátis.
  // Regra atual: estado inteiro de SP + Distrito Federal (DF).
  // (Para entrega no mesmo dia, vale apenas SP capital — vide isCapitalSP)
  function isFreeShippingEligible(addr) {
    if (!addr) return false;
    var uf = (addr.uf || addr.estado || '').toUpperCase().trim();
    return uf === 'SP' || uf === 'DF';
  }

  function renderFreeshipBar() {
    var bar = document.querySelector('[data-vin-freeship-bar]');
    if (!bar) return;

    var threshold = parseFloat(bar.dataset.threshold) || 1000;
    var subtotal = parseFloat(bar.dataset.cartSubtotal) || 0;

    var iconEl = bar.querySelector('[data-vin-freeship-icon]');
    var textEl = bar.querySelector('[data-vin-freeship-text]');
    var progressEl = bar.querySelector('[data-vin-freeship-progress]');
    var fillEl = bar.querySelector('[data-vin-freeship-progress-fill]');
    var ctaEl = bar.querySelector('[data-vin-freeship-cta]');

    var addr = getSavedAddress();
    var hasCep = !!addr;
    var eligible = isFreeShippingEligible(addr);

    bar.classList.remove('vin-freeship-bar--success', 'vin-freeship-bar--info', 'vin-freeship-bar--prompt');

    if (!hasCep) {
      bar.classList.add('vin-freeship-bar--prompt');
      if (iconEl) iconEl.textContent = '🎁';
      if (textEl) textEl.innerHTML = 'Frete grátis acima de <strong>' + formatBRLReais(threshold) + '</strong>';
      if (progressEl) progressEl.hidden = true;
      if (ctaEl) ctaEl.hidden = false;
      return;
    }

    if (ctaEl) ctaEl.hidden = true;

    if (!eligible) {
      bar.classList.add('vin-freeship-bar--info');
      if (iconEl) iconEl.textContent = 'ℹ️';
      if (textEl) textEl.textContent = 'Frete grátis disponível apenas em SP e DF';
      if (progressEl) progressEl.hidden = true;
      return;
    }

    if (subtotal >= threshold) {
      bar.classList.add('vin-freeship-bar--success');
      if (iconEl) iconEl.textContent = '✅';
      if (textEl) textEl.innerHTML = '<strong>Parabéns!</strong> Você ganhou frete grátis';
      if (progressEl) progressEl.hidden = true;
      return;
    }

    var missing = threshold - subtotal;
    var pct = Math.min(100, Math.max(0, (subtotal / threshold) * 100));

    if (iconEl) iconEl.textContent = '🎁';
    if (textEl) textEl.innerHTML = 'Faltam <strong>' + formatBRLReais(missing) + '</strong> para frete grátis';
    if (progressEl) progressEl.hidden = false;

    // Nova abordagem: seta a porcentagem como CSS variable no track.
    // O CSS desenha o gradient baseado em --vin-progress.
    // Sem race condition entre 2 elementos, sem dependência de
    // measurement de largura, sem transition de width.
    if (progressEl) {
      progressEl.style.setProperty('--vin-progress', pct + '%');
    }
  }

  /* ============================================================
     FAIXA "RECEBA HOJE" (entrega no mesmo dia)
     Calcula tempo até o horário de corte e mostra contador.
     Só aparece se cliente é SP capital + tem CEP + antes do corte.
     Roda a cada 60s pra manter atualizado.
     ============================================================ */

  // Pega data/hora atual no fuso America/Sao_Paulo (NÃO usa hora local
  // do device, porque cliente pode estar viajando ou com fuso errado).
  function nowInSaoPaulo() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false, weekday: 'short'
    });
    var parts = fmt.formatToParts(new Date()).reduce(function(acc, p) {
      acc[p.type] = p.value;
      return acc;
    }, {});
    return {
      year: parseInt(parts.year, 10),
      month: parseInt(parts.month, 10),
      day: parseInt(parts.day, 10),
      hour: parseInt(parts.hour, 10),
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10),
      // weekday em PT-BR via index: 0=dom, 1=seg, ..., 6=sáb
      weekdayIndex: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(parts.weekday),
      isoDate: parts.year + '-' + parts.month + '-' + parts.day
    };
  }

  // Verifica se a data atual (YYYY-MM-DD) está na lista de feriados
  function isHoliday(isoDate, holidaysCsv) {
    if (!holidaysCsv) return false;
    return holidaysCsv.split(',').some(function(d) {
      return d.trim() === isoDate;
    });
  }

  // Formata tempo restante (ms) como "3h 25min" ou "30min"
  function formatTimeLeft(ms) {
    var totalMin = Math.floor(ms / 60000);
    if (totalMin <= 0) return null;
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    if (h > 0 && m > 0) return { text: h + 'h ' + m + 'min', hasHours: true };
    if (h > 0) return { text: h + 'h', hasHours: true };
    return { text: m + 'min', hasHours: false };
  }

  function renderDeliveryToday() {
    var bar = document.querySelector('[data-vin-delivery-today]');
    if (!bar) return; // setting desativado, nada a fazer

    // Helper: esconde a linha E remove classe do container pai
    // (pra layout voltar ao normal quando a linha some)
    function hideDelivery() {
      bar.style.display = 'none';
      var freeshipBar = document.querySelector('[data-vin-freeship-bar]');
      if (freeshipBar) freeshipBar.classList.remove('vin-freeship-bar--with-delivery');
    }

    // Verifica elegibilidade do endereço (mesma lógica da faixa de frete)
    var addr = getSavedAddress();
    if (!addr) {
      hideDelivery();
      return;
    }
    if (!isMotoboyCidade(addr)) {
      hideDelivery();
      return;
    }

    // Lê configurações do data-attrs (setadas via Liquid pelos settings)
    var cutoffWeekday = parseInt(bar.dataset.cutoffWeekday, 10) || 17;
    var cutoffWeekend = parseInt(bar.dataset.cutoffWeekend, 10) || 14;
    var holidays = bar.dataset.holidays || '';
    var urgentMinutes = parseInt(bar.dataset.urgentMinutes, 10) || 30;

    // Lê textos personalizáveis (settings do Customizador, com fallbacks)
    var todayTitle = bar.dataset.todayTitle || 'Receba hoje';
    var todaySubPrefix = bar.dataset.todaySubPrefix || 'Comprando dentro';
    var tomorrowTitle = bar.dataset.tomorrowTitle || ('Chega amanhã ' + labelCidade(addr));
    var tomorrowSubPrefix = bar.dataset.tomorrowSubPrefix || 'Comprando dentro';

    // Helper: pega título configurável e marca em <strong> a última palavra
    // (mantém o estilo visual com burgundy no destaque)
    function emphasizeLastWord(text) {
      var words = text.trim().split(' ');
      if (words.length < 2) return text;
      var last = words.pop();
      return words.join(' ') + ' <strong>' + last + '</strong>';
    }

    // Hora atual em SP
    var now = nowInSaoPaulo();
    var isWeekend = now.weekdayIndex === 0 || now.weekdayIndex === 6; // dom ou sáb
    var isFeriado = isHoliday(now.isoDate, holidays);
    var cutoffHour = (isWeekend || isFeriado) ? cutoffWeekend : cutoffWeekday;

    // Calcula minutos restantes até o corte (sem cair em fuso do device)
    var currentMinutes = now.hour * 60 + now.minute;
    var cutoffMinutes = cutoffHour * 60;
    var minutesLeft = cutoffMinutes - currentMinutes;

    var iconEl = bar.querySelector('[data-vin-delivery-today-icon]');
    var titleEl = bar.querySelector('[data-vin-delivery-today-title]');
    var subEl = bar.querySelector('[data-vin-delivery-today-sub]');

    if (minutesLeft <= 0) {
      // Passou do corte — mostra "Chega amanhã"
      var tomorrowIndex = (now.weekdayIndex + 1) % 7; // 0=dom..6=sáb
      var tomorrowIsWeekend = tomorrowIndex === 0 || tomorrowIndex === 6;

      var tomorrowIso = (function() {
        var d = new Date();
        d.setDate(d.getDate() + 1);
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo',
          year: 'numeric', month: '2-digit', day: '2-digit'
        });
        var parts = fmt.formatToParts(d).reduce(function(a, p) { a[p.type] = p.value; return a; }, {});
        return parts.year + '-' + parts.month + '-' + parts.day;
      })();
      var tomorrowIsFeriado = isHoliday(tomorrowIso, holidays);

      var tomorrowCutoff = (tomorrowIsWeekend || tomorrowIsFeriado) ? cutoffWeekend : cutoffWeekday;

      // Calcula minutos do AGORA até o corte de amanhã
      // (24h * 60 minutos) - minutos passados desde meia-noite + minutos até o corte
      var minutesUntilMidnight = (24 * 60) - currentMinutes;
      var minutesTomorrowToCutoff = tomorrowCutoff * 60;
      var minutesUntilTomorrowCutoff = minutesUntilMidnight + minutesTomorrowToCutoff;
      var msUntilTomorrowCutoff = minutesUntilTomorrowCutoff * 60000 - now.second * 1000;

      // Formata o tempo restante. Se faltam mais de 12h, mostra
      // formato amigável "amanhã às Xh" em vez de "23h 45min".
      // Senão, usa o mesmo formato do contador "Receba hoje".
      var tomorrowSubText;
      if (minutesUntilTomorrowCutoff > 12 * 60) {
        tomorrowSubText = tomorrowSubPrefix + ' até amanhã às <strong>' + tomorrowCutoff + 'h</strong>';
      } else {
        var tomorrowTime = formatTimeLeft(msUntilTomorrowCutoff);
        if (tomorrowTime) {
          var artigoTomorrow = tomorrowTime.hasHours ? 'as próximas' : 'os próximos';
          tomorrowSubText = tomorrowSubPrefix + ' d' + artigoTomorrow + ' <strong>' + tomorrowTime.text + '</strong>';
        } else {
          // Fallback se algo der errado no cálculo
          tomorrowSubText = tomorrowSubPrefix + ' até amanhã às <strong>' + tomorrowCutoff + 'h</strong>';
        }
      }

      bar.style.display = '';
      bar.classList.remove('vin-delivery-today--urgent');
      iconEl.textContent = '📦';
      titleEl.innerHTML = emphasizeLastWord(tomorrowTitle);
      subEl.innerHTML = tomorrowSubText;

      // Fallback pra navegadores sem :has()
      var freeshipBar1 = document.querySelector('[data-vin-freeship-bar]');
      if (freeshipBar1) freeshipBar1.classList.add('vin-freeship-bar--with-delivery');
      return;
    }

    // Tem tempo — mostra a faixa
    bar.style.display = '';

    var msLeft = minutesLeft * 60000 - now.second * 1000;
    var t = formatTimeLeft(msLeft);
    if (!t) {
      hideDelivery();
      return;
    }

    // Define artigo correto: "próximAS Xh Ymin" vs "próximOS Xmin"
    var artigo = t.hasHours ? 'as próximas' : 'os próximos';

    // Estado urgente?
    var isUrgent = minutesLeft <= urgentMinutes;

    if (isUrgent) {
      iconEl.textContent = '⚡';
      bar.classList.add('vin-delivery-today--urgent');
    } else {
      iconEl.textContent = '⏰';
      bar.classList.remove('vin-delivery-today--urgent');
    }

    titleEl.innerHTML = emphasizeLastWord(todayTitle);
    subEl.innerHTML = todaySubPrefix + ' d' + artigo + ' <strong>' + t.text + '</strong>';

    // Fallback pra navegadores sem :has() — adiciona classe no container
    var freeshipBar = document.querySelector('[data-vin-freeship-bar]');
    if (freeshipBar) {
      freeshipBar.classList.add('vin-freeship-bar--with-delivery');
    }
  }

  // Importante: renderDeliveryToday() roda PRIMEIRO porque adiciona a
  // classe .vin-freeship-bar--with-delivery (que muda o layout pra column).
  // Se renderFreeshipBar rodar antes, calcula a largura da barra com
  // o layout horizontal antigo, e o reflow subsequente pode bagunçar
  // o transition de width do .vin-freeship-progress-fill.
  renderDeliveryToday();
  renderFreeshipBar();

  // Atualiza o contador "Receba hoje" a cada 60s pra ficar sempre fresco.
  // Não atualizar o frete grátis porque ele não depende do tempo.
  setInterval(renderDeliveryToday, 60000);

  window.addEventListener('storage', function(e) {
    if (e.key === 'vinheria_address') {
      renderDeliveryToday();
      renderFreeshipBar();
    }
  });
  window.addEventListener('vinheria:address-updated', function(e) {
    if (e.detail) updateCartAddress(e.detail);
    renderDeliveryToday();
    renderFreeshipBar();
  });

})();